"use client";

import Cookies from "js-cookie";
import { Dispatch, SetStateAction, useEffect, useState } from "react";

export default function WANotice({
  callback,
  setShowWANotice,
}: {
  callback: () => void;
  setShowWANotice: Dispatch<SetStateAction<boolean>>;
}) {
  const DELAY = 8000;
  const [showWANoticeInternal, setShowWANoticeInternal] = useState(false);

  useEffect(() => {
    if (!Cookies.get("wa-shown")) {
      setTimeout(() => {
        setShowWANoticeInternal(true);
        setShowWANotice(true);
        callback();
      }, DELAY);
    }
  }, []);

  return (
    <>
      {showWANoticeInternal ? (
        <div className="w-full flex justify-center relative mt-6 sm:mt-0">
          <div className="relative w-full max-w-[260px] md:max-w-[30%] text-center text-xs bg-quaternary-bg p-2 pr-4 radius-base border-1 border-base-text border-dashed pt-3">
            <b>
              TEAM BUILDING, CUMPLEAÑOS, TEAM BUILDING, DESPEDIDAS DE SOLTERA
            </b>
            <br />
            ¡La mejor experiencia en un workshop original y divertido!
            <br />
            <a
              href="https://api.whatsapp.com/send?phone=34623744039"
              target="_blank"
              title="Escríbenos un WhatsApp para más información."
              className="underline"
            >
              Escríbenos un WhatsApp para más información.
            </a>
            <div
              className="absolute bg-transparent text-secondary-text font-bold p-0 m-0 top-1 right-2 cursor-pointer"
              onClick={() => {
                setShowWANoticeInternal(false);
                setShowWANotice(false);
                Cookies.set("wa-shown", "true", { expires: 30 });
                callback();
              }}
            >
              x
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
